<template>
  <div class="cancel-with-box">
    <div class="d-flex ">
      <div class="d-flex align-items-center justify-content-between w-100">
        <div class="font-weight-bold">{{ 'Cancel Task' | trans }}</div>
        <div class="text-muted">{{'No Credits will be charged' | trans}}</div>
      </div>
      <div class="text-muted font-weight-bold"></div>
    </div>
    <div class="cancel-btn-box">

      <div class="cancel-btn" @click="cancelTask()">
        <div class="cancel-btn-text">
          <i class="far fa-times"></i> {{ 'Cancel Task' | trans }}
        </div>
        <div class="d-none"><i class="far fa-arrow-right"></i></div>
      </div>
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import {EventBus} from "../../events/event.bus";
import JobManager from "../../manager/JobManager";
import { EVENT_JOB_CANCEL_INIT} from '../../events/job.events';

export default {
  name: "CancelTask",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob,
  ],
  data() {
    return {
    };
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    cancelTask() {
        if (this.currentJob.state === 'not_found') {
            return;
        }
        EventBus.$emit(EVENT_JOB_CANCEL_INIT, this.currentJob?.apiJob?.id);
    },
  },
  computed: {}
};
</script>
<style lang="scss" scoped>
.cancel-with-box {
  display: flex;
  flex-direction:column;
  gap: 20px;
}
.cancel-btn-box {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.disabled {
  opacity: .5;
  cursor: not-allowed !important;
}

.cancel-btn {
  display: flex;
  background: #F8F9FA;
  border: 1px solid #CBCBCB;
  border-radius: 4px;
  justify-content: space-between;
  padding: 10px 20px;
  align-items: center;
  cursor: pointer;

  .dark-mode & {
    background:#383838;;
    border: 1px solid #595959;
    color: white;
    &:hover {
      background: #323232;
    }
  }

  &:hover {
    background: #F2F2F2;
  }

  .cancel-btn-text {
    display: flex;
    gap: 10px;
    align-items: center;
  }
}

</style>
